/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DietAddonGroupDietAddonsRead,
  GetDietAddonsParams
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type get_diet_addonsResponse200 = {
  data: DietAddonGroupDietAddonsRead[]
  status: 200
}

export type get_diet_addonsResponseSuccess = (get_diet_addonsResponse200) & {
  headers: Headers;
};
;

export type get_diet_addonsResponse = (get_diet_addonsResponseSuccess)

export const getGetDietAddonsUrl = (dietId: string,
    params?: GetDietAddonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/diet/${dietId}/addons?${stringifiedParams}` : `/api/diet/${dietId}/addons`
}

/**
 * Retrieves the collection of DietAddonGroup resources.
 * @summary Retrieves addons available for a diet, grouped by category.
 */
export const get_diet_addons = async (dietId: string,
    params?: GetDietAddonsParams, options?: RequestInit): Promise<get_diet_addonsResponse> => {

  return apiCatalog<get_diet_addonsResponse>(getGetDietAddonsUrl(dietId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDietAddonsQueryKey = (dietId: string,
    params?: GetDietAddonsParams,) => {
    return [
    `/api/diet/${dietId}/addons`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDietAddonsQueryOptions = <TData = Awaited<ReturnType<typeof get_diet_addons>>, TError = unknown>(dietId: string,
    params?: GetDietAddonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDietAddonsQueryKey(dietId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_diet_addons>>> = ({ signal }) => get_diet_addons(dietId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: dietId !== null && dietId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDietAddonsQueryResult = NonNullable<Awaited<ReturnType<typeof get_diet_addons>>>
export type GetDietAddonsQueryError = unknown


export function useGetDietAddons<TData = Awaited<ReturnType<typeof get_diet_addons>>, TError = unknown>(
 dietId: string,
    params: undefined |  GetDietAddonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_diet_addons>>,
          TError,
          Awaited<ReturnType<typeof get_diet_addons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDietAddons<TData = Awaited<ReturnType<typeof get_diet_addons>>, TError = unknown>(
 dietId: string,
    params?: GetDietAddonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_diet_addons>>,
          TError,
          Awaited<ReturnType<typeof get_diet_addons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDietAddons<TData = Awaited<ReturnType<typeof get_diet_addons>>, TError = unknown>(
 dietId: string,
    params?: GetDietAddonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves addons available for a diet, grouped by category.
 */

export function useGetDietAddons<TData = Awaited<ReturnType<typeof get_diet_addons>>, TError = unknown>(
 dietId: string,
    params?: GetDietAddonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_addons>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDietAddonsQueryOptions(dietId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






